module.exports = __webpack_public_path__ + "img/P42-en.cd968ade.png";